<ion-col class="deinstag-modal-root" style="text-align: center">
	<p style="font-size: 1.2em; font-weight: bold">{{ 'deinstag_modal.title' | translate }}</p>
	<p>{{ 'deinstag_modal.subtitle' | translate }}</p>
	<p style="font-size: 0.9em">{{ 'deinstag_modal.conditions' | translate }}</p>
	<ion-button class="confirm-button ion-margin-bottom" shape="round" (click)="onConfirmClick()">
		{{ 'deinstag_modal.confirm' | translate }}
	</ion-button>
	<br />
	<ion-button class="decline-button" shape="round" (click)="onDeclineClick()"> {{ 'deinstag_modal.decline' | translate }} </ion-button>
</ion-col>
